import { AttributeValue, GetAttributeValuesRequest, GetAttributeValuesResponse } from 'pbts/c1/api/attribute/v1/attribute'
import { AttributesClient } from 'pbts/c1/api/attribute/v1/attribute.client'
import { createMultiGetApi, MultiGetOpts } from 'redux_toolkit/lib/createMultiGetApi'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'

export type AttributeValueRef = {
    id: string
    typeName: string
}

export const AttributeValueRefTypeName = 'c1.api.attribute.v1.AttributeValue'

export const attributeGetApi = createUnaryApi(AttributesClient, 'getAttributeValue')

export const getAttributesApi = createUnaryApi(AttributesClient, 'getAttributeValues')

export const listRiskLevelsApi = createPagedListApi(AttributesClient, 'listRiskLevels')

export const listComplianceFrameworksApi = createPagedListApi(AttributesClient, 'listComplianceFrameworks')

const multiGetAttributeValueOpts: MultiGetOpts<AttributeValueRef, GetAttributeValuesRequest, GetAttributeValuesResponse, AttributeValue> = {
    buildRequest: (refs: AttributeValueRef[]) => GetAttributeValuesRequest.create({
        attributeIds: refs.map((ref) => ref.id),
    }),
    transformResponse: (res: GetAttributeValuesResponse) => {
        return res.items || []
    },
    refExtractor: (item: AttributeValue): AttributeValueRef => {
        return { id: item.id, typeName: AttributeValueRefTypeName }
    },
    maxBatchSize: 100,
    enableWebsocketRefresh: false,
    tag: AttributeValueRefTypeName,
}

export const attributeValueMultiGetApi = createMultiGetApi(
    AttributesClient,
    'getAttributeValues',
    multiGetAttributeValueOpts,
)
